import { styled } from "styled-components";

export const StyledHelpButton = styled.div`
  display: flex;
  position: fixed;
  bottom: 1em;
  right: 1em;
`;
